"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Loader_1 = require("./Loader");
function useLoader(_a) {
    if (_a === void 0) { _a = tslib_1.__assign({ isLoading: false, Component: Loader_1.Loader }, {}); }
    var Component = _a.Component, isLoading = _a.isLoading, props = tslib_1.__rest(_a, ["Component", "isLoading"]);
    var _b = tslib_1.__read(react_1.useState(isLoading || false), 2), isLoadingState = _b[0], setLoading = _b[1];
    return {
        loader: react_1.default.createElement(react_1.default.Fragment, null, isLoadingState && react_1.default.createElement(Component, tslib_1.__assign({}, props))),
        setLoading: setLoading,
        isLoading: isLoadingState,
    };
}
exports.useLoader = useLoader;
//# sourceMappingURL=useLoader.js.map